module.exports = "https://cdn-skillquest.mathletics.com/app/170/assets/images/c80ec511909f241ae87ce5735f852ec2.svg";